import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Empty, Spin } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import TimesheetGrid from './TimesheetGrid';
import WeekPicker from '../../common/components/WeekPicker';
import { GET_USER_TIMESHEET } from '../queries';
import { getWeekEndDayForDate } from '../../common';

interface PrefillTimesheetProps {
    onTimesheetChange: (timesheetId: string) => void;
    userId: string;
    endDate: string;
}

const getPreviousWeekEndDate = (currentEndDate: string) => {
    const mapToMoment: Record<string, number> = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };
    
    // Start from the day before the current end date
    let targetDate = moment(currentEndDate).subtract(1, 'day');
    
    // Scan for up to 14 days to find the correct previous week end day
    for (let i = 0; i < 14; i++) {
        const weDay = getWeekEndDayForDate(targetDate);
        const weDayIndex = mapToMoment[weDay];
        
        if (targetDate.day() === weDayIndex) {
            return targetDate.format('YYYYMMDD');
        }
        
        targetDate.subtract(1, 'day');
    }
    
    // Fallback to simple subtraction if no match found
    return moment(currentEndDate).subtract(1, 'week').format('YYYYMMDD');
};

const PrefillTimesheet: React.FC<PrefillTimesheetProps> = ({ onTimesheetChange, userId, endDate: initialEndDate }) => {
    const [endDate, setEndDate] = useState(() => getPreviousWeekEndDate(initialEndDate));
    const { data, loading } = useQuery(GET_USER_TIMESHEET, {
        variables: {
            endDate: endDate,
            user: userId,
        },
    });

    const timesheet = data?.timesheet;

    useEffect(() => {
        if (timesheet) {
            onTimesheetChange(timesheet._id);
        }
    }, [timesheet, onTimesheetChange]);

    return (
        <div className="">
            <div className="flex flex-row justify-end">
                <WeekPicker onDateChange={(value) => {
                    setEndDate(moment(value).format('YYYYMMDD'));
                }} endDate={endDate} />
            </div>
            <div className="mt-4 overflow-x-auto">
                {loading ? <div className="flex justify-center py-8"><Spin /></div> :
                    timesheet && <TimesheetGrid
                        className="min-w-[1000px]"
                        endDate={timesheet.endDate}
                        timesheetId={timesheet._id}
                        lineItems={timesheet.lineItems}
                        isLocked={true}
                        shouldAllowSubmit={() => false}
                        userId={userId}
                    />}
                {!loading && !timesheet && (
                    <div className="py-8">
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="No timesheet found for this week"
                        />
                    </div>
                )}
            </div>
        </div>

    );
};

export default PrefillTimesheet;